import { Url } from '../shared/Url';
import Post from '../shared/Post';
import { consultaUser } from './PefilFunction';
import { cookieData } from '../funciones/ConsultaUser';
import { requerido, numero, requeridoFile } from './Validaciones'

export const ConsultCuenta = (respuesta) => {
    consultaUser((estudiante) => {
        let Content = {
            id: estudiante,
        }
        Post(`${Url}ConsultEstCuenta`, Content, (resp) => {
            let data = JSON.parse(resp);

            respuesta(data[0])
        });
    });
}

export const ConsultCuentaAdmin = (est, respuesta) => {
    let Content = {
        id: est,
    }

    Post(`${Url}ConsultEstCuentaAdmin`, Content, (resp) => {
        let data = JSON.parse(resp);
        respuesta(data[0])
    });
}

export const ConsultCuentaAdminHist = (est, respuesta) => {
    let Content = {
        id: est,
    }

    Post(`${Url}ConsultEstCuentaAdmin`, Content, (resp) => {
        let data = JSON.parse(resp);
        respuesta([data[0], data[1]])
    });
}

export const ConsultaAsiento = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            id: id,
            uId: cookie[1]
        }
        Post(`${Url}ConsultaAsiento`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });
}

export const consultCuotas = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            id: id,
            uId: cookie[1]
        }
        Post(`${Url}consultCuotas`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });
    });
}

export const EditAsiento = (id, fecha, item, debe, haber, saldo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            id: id,
            uId: cookie[1],
            fecha: fecha,
            item: item,
            debe: debe,
            haber: haber,
            saldo: saldo
        }

        Post(`${Url}EditAsiento`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });
    });
}

export const ConsultaDeuda = (respuesta) => {
    consultaUser((estudiante) => {console.log(estudiante);
        let Content = {
            id: estudiante,
        }

        Post(`${Url}ConsultDeuda`, Content, (resp) => {
            let data = JSON.parse(resp);
            let contenido = {
                status: data.status,
                fecha: data.fecha,
                vencimiento: data.vence,
                deuda: data.total,
                deudaVencida: data.totalVencido,
                interes: data.interes,
                totalGral: data.totalGeneral,
                info: data.info,
                classInfo: data.classInfo,
                icono: data.icono,
                errores: data.errores
            }
            /* console.log(contenido) */
            respuesta(contenido)
        });
    });
}

export const ConsultaDeudaEst2 = (estudiante, respuesta) => {
    let Content = {
        id: estudiante,
    }

    Post(`${Url}ConsultDeuda`, Content, (resp) => {
        let data = JSON.parse(resp);
        let contenido = {
            status: data.status,
            fecha: data.fecha,
            vencimiento: data.vence,
            deuda: data.total,
            deudaVencida: data.totalVencido,
            interes: data.interes,
            totalGral: data.totalGeneral,
            info: data.info,
            classInfo: data.classInfo,
            icono: data.icono,
            errores: data.errores
        }
        /* console.log(contenido) */
        respuesta(contenido)
    });
}

export const ConsultaDeudaEst = (id, respuesta) => {
    let Content = {
        id: id,
    }

    Post(`${Url}ConsultDeudaEst`, Content, (resp) => {
        let data = JSON.parse(resp);
        let contenido = {
            status: data.status,
            fecha: data.fecha,
            vencimiento: data.vence,
            deuda: data.total,
            deudaVencida: data.totalVencido,
            interes: data.interes,
            totalGral: data.totalGeneral,
            info: data.info,
            classInfo: data.classInfo,
            icono: data.icono,
            errores: data.errores,
            carreras: data.carreras,
            igtf: data.ValorIGTF
        }
        /* console.log(contenido) */
        respuesta(contenido)
    });
}

export const Pagar = (campos, vencida, respuesta) => {
    let status = "Ok";
    let mensaje = "Se ha registrado correctamente el pago, espera su validación";
    let tipoMes = "info";
    let errores = 0
    
    requerido(errores, campos.fecha, "", "", "", "Debes ingresar la Fecha de la Transferencia", (resp) => {
        if (resp[1] > 0){
            status = "Error";
            mensaje= resp[2];
            tipoMes = "error";
        }
    });

    if (campos.selectcuenta.oblig === 1){
        requerido(errores, campos.num, "", "", "", "Debes ingresar el Número de la Transferencia", (resp) => {
            if (resp[1] > 0){
                status = "Error";
                mensaje= resp[2];
                tipoMes = "error";
            }
        });

        if (campos.num !== ""){
            numero(errores, campos.num, "", "", "El campo N° de Transferencia debe contener solo números", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
        }
    }

    requerido(errores, campos.selectcuenta.value, "", "", "", "Debes seleccionar la Cuenta de la Transferencia", (resp) => {
        if (resp[1] > 0){
            status = "Error";
            mensaje= resp[2];
            tipoMes = "error";
        }
    });

    if(campos.total === true){
        requerido(errores, campos.deudaT.totalGral, "", "", "", "El Monto Total no puede estar vacío", (resp) => {
            if (resp[1] > 0){
                status = "Error";
                mensaje= resp[2];
                tipoMes = "error";
            }
        });
        if (campos.deudaT.totalGral !== ""){
            numero(errores, campos.deudaT.totalGral, "", "", "El campo Monto Total debe contener solo números", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
        }
    }else{
        requerido(errores, campos.otroMonto, "", "", "", "El Monto no puede estar vacío", (resp) => {
            if (resp[1] > 0){
                status = "Error";
                mensaje= resp[2];
                tipoMes = "error";
            }
        });
        if (campos.otroMonto !== ""){
            numero(errores, campos.otroMonto, "", "", "El campo Otro Monto debe contener solo números", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
        }
    }

    requerido(errores, campos.titular, "", "", "", "Debes indicar el Nombre del Titular de la Cuenta", (resp) => {
        if (resp[1] > 0){
            status = "Error";
            mensaje= resp[2];
            tipoMes = "error";
        }
    });

    requerido(errores, campos.ciTitular, "", "", "", "Debes indicar la Cédula del Titular de la Cuenta", (resp) => {
        if (resp[1] > 0){
            status = "Error";
            mensaje= resp[2];
            tipoMes = "error";
        }
    });
    
    if(campos.selectcuenta.tipo === "PAGO MÓVIL" || campos.selectcuenta.tipo === "PAGO MOVIL"){
        requeridoFile(errores, campos.tlfTitular, "", "", "", "Debes indicar el número de teléfono del Pago Móvil", (resp) => {
            if (resp[1] > 0){
                status = "Error";
                mensaje= resp[2];
                tipoMes = "error";
            }
        });

        numero(errores, campos.tlfTitular, "", "", "El campo Teléfono del Pago Móvil debe contener solo números", (resp) => {
            if (resp[1] > 0){
                status = "Error";
                mensaje= resp[2];
                tipoMes = "error";
            }
        });
    }

    if (status === "Ok"){
        consultaUser((estudiante) => {
            let Content = {
                id: estudiante,
                campos: campos,
                vencida: vencida
            }
            
            Post(`${Url}pagarCuota`, Content, (resp) => {
                let data = JSON.parse(resp);

                if (data.status === "ErrorRef") {
                    status = "Error";
                    mensaje= data.mess;
                    tipoMes = "error";
                }

                respuesta([status, mensaje, tipoMes])
            });
        });
    }else{
        respuesta([status, mensaje, tipoMes])
    }
}

export const PagarInd = (id, tipo, campos, vencida, respuesta) => {
    let status = "Ok";
    let mensaje = "Haz registrado correctamente el pago del estudiante";
    let tipoMes = "info";
    let errores = 0

    /* Validaciones globales*/
    requerido(errores, campos.fecha, "", "", "", "Debes ingresar la Fecha de la Transferencia", (resp) => {
        if (resp[1] > 0){
            status = "Error";
            mensaje= resp[2];
            tipoMes = "error";
        }
    });

    requerido(errores, campos.factura, "", "", "", "Debes ingresar el Número de la Factura", (resp) => {
        if (resp[1] > 0){
            status = "Error";
            mensaje= resp[2];
            tipoMes = "error";
        }
    });

    if (campos.metodoSelect.label !== "DIVISA"){
        if(campos.total === true){
            requerido(errores, campos.deudaT.totalGral, "", "", "", "El Monto Total no puede estar vacío", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
            if (campos.deudaT.totalGral !== ""){
                numero(errores, campos.deudaT.totalGral, "", "", "El campo Monto Total debe contener solo números", (resp) => {
                    if (resp[1] > 0){
                        status = "Error";
                        mensaje= resp[2];
                        tipoMes = "error";
                    }
                });
            }
        }else{
            requerido(errores, campos.otroMonto, "", "", "", "El Monto no puede estar vacío", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
            if (campos.otroMonto !== ""){
                numero(errores, campos.otroMonto, "", "", "El campo Otro Monto debe contener solo números", (resp) => {
                    if (resp[1] > 0){
                        status = "Error";
                        mensaje= resp[2];
                        tipoMes = "error";
                    }
                });
            }
        }
    }

    /* Validaciones específicas */
    switch (campos.metodoSelect.label) {
        case "EFECTIVO":
            /* Sin validaciones adicionales */
        break;
        case "DIVISA":
            requerido(errores, campos.divisas, "", "", "", "Debes ingresar el monto del pago en divisas", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
            if (campos.divisas !== ""){
                numero(errores, campos.divisas, "", "", "El campo Monto en divisas debe contener solo números", (resp) => {
                    if (resp[1] > 0){
                        status = "Error";
                        mensaje= resp[2];
                        tipoMes = "error";
                    }
                });
            }
        break;
        case "TRANSFERENCIA":
            requerido(errores, campos.selectcuenta.value, "", "", "", "Debes seleccionar la Cuenta de la Transferencia", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
            requerido(errores, campos.num, "", "", "", "Debes ingresar el Número de Referencia", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
        
            if (campos.num !== ""){
                numero(errores, campos.num, "", "", "El campo N° de Referencia debe contener solo números", (resp) => {
                    if (resp[1] > 0){
                        status = "Error";
                        mensaje= resp[2];
                        tipoMes = "error";
                    }
                });
            }
        break;
        case "DEBITO":
            requerido(errores, campos.num, "", "", "", "Debes ingresar el Número de Referencia", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
        
            if (campos.num !== ""){
                numero(errores, campos.num, "", "", "El campo N° de Referencia debe contener solo números", (resp) => {
                    if (resp[1] > 0){
                        status = "Error";
                        mensaje= resp[2];
                        tipoMes = "error";
                    }
                });
            }
        case "CREDITO":
            requerido(errores, campos.num, "", "", "", "Debes ingresar el Número de Referencia", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
        
            if (campos.num !== ""){
                numero(errores, campos.num, "", "", "El campo N° de Referencia debe contener solo números", (resp) => {
                    if (resp[1] > 0){
                        status = "Error";
                        mensaje= resp[2];
                        tipoMes = "error";
                    }
                });
            }
        default: break;
    }

    if (status === "Ok"){
        cookieData((cookie) => {
            let Content = {
                uId: cookie[1],
                id: id,
                campos: campos,
                tipo: tipo
            }
    
            Post(`${Url}pagarCuotaInd`, Content, (resp) => {
                let data = JSON.parse(resp);

                if (data.status === "ErrorRef") {
                    status = "Error";
                    mensaje= data.mess;
                    tipoMes = "error";

                    respuesta([status, mensaje, tipoMes])
                }else{
                    let Content2 = {
                        uId: cookie[1],
                        id: data.recibo,
                        factura: campos.factura,
                        vencida: vencida
                    }
    
                    mensaje = data.mess;
                    let total = data.total;
    
                    Post(`${Url}AprobarTrans`, Content2, () => {
                        respuesta([status, mensaje, tipoMes, total])
                    });
                }
            });
        });
    }else{
        respuesta([status, mensaje, tipoMes])
    }
}

export const ConsultaNumCuenta = (respuesta) => {
    Post(`${Url}ConsultNumCuenta`, "", (resp) => {
        let data = JSON.parse(resp);

        let contenido = [];
        
        for (let i in data[0]){
            let nombre = `${data[0][i].banco} - [${data[0][i].cuenta}]`;

            if (data[0][i].tipo === "PAGO MÓVIL" || data[0][i].tipo === "PAGO MOVIL") nombre = `${data[0][i].tipo} ${data[0][i].banco} - [${data[0][i].cuenta}]`;
            
            contenido.push({
                value: data[0][i].id, label: nombre, tipo: data[0][i].tipo, oblig: data[0][i].ref_oblig
            })
        }

        respuesta([data[0], contenido])
    });
}

export const PagoEfectivo = (respuesta) => {
    consultaUser((estudiante) => {
        let Content = {
            id: estudiante,
        }
        Post(`${Url}PagoEfectivo`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });
    });
}

export const CantAsientosRechazados = (tipo, mes, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            tipo: tipo,
            mes: mes
        }

        Post(`${Url}CantAsientosRechazados`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });
    });
}


// WEBPACK FOOTER //
// ./src/funciones/EstCuentaFunction.jsx